import isEmpty from 'lodash/isEmpty'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'

import Item from './Item'
import EmptyData from './EmptyData'

import useTranslate from '../../../i18n/useTranslate'
import { Officer, Order } from '../../../services/um/useSearchOfficer'

interface Props {
    order: Order
    officers: Officer[]
    onDelete: (userID: number | string) => void
    onSort: (value: Order) => void
}

const Result: React.FC<Props> = ({ officers, onDelete, onSort, order }) => {
    const translate = useTranslate()
    const classes = useStyles()
    const history = useHistory()

    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    // const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
    //     onSort(event.target.value)
    // }

    const GotoAddOfficer = () => {
        history.push('/officer/add')
    }

    const getFullName = (officerItem: typeof officers[0]) => {
        let name = officerItem.fullnameTH
        if (translate.languageStore.currentLanguage === translate.languageKey.en) {
            name = officerItem.fullnameEN
        }
        return name
    }

    return (
        <div className={classes.container}>
            <Grid container justify="space-between" alignItems="center">
                <Grid item xs={12} md={6}>
                    <Typography variant="h6">
                        {translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${officers.length}`])}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container justify="flex-end">
                        <Grid item>
                            <Button
                                size="large"
                                variant="outlined"
                                color="primary"
                                onClick={GotoAddOfficer}
                                startIcon={<AddIcon />}
                            >
                                <Typography variant="button">
                                    {translate.get('UM.USERGROUP.ADD-BUTTON-LABEL')}
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {/* <Grid container alignItems="center" className={classes.sorting} spacing={2}>
                <Grid item>
                    <Typography>{translate.get('UM.USERGROUP.SORTING-LABEL')}</Typography>
                </Grid>
                <Grid item>
                    <Select
                        name="group"
                        variant="outlined"
                        className={classes.select}
                        label={translate.get('UM.USERGROUP.OFFICER.STATUS-LABEL')}
                        onChange={handleChange}
                        value={order}
                    >
                        {sorts.map((item) => (
                            <MenuItem value={item.value}>{item.label[lang]}</MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid> */}
            <EmptyData isEmpty={isEmpty(officers)}>
                <Grid style={{ overflowY: 'auto', marginTop: '10px' }}>
                    {officers.map((officer) => {
                        // const newData = {
                        //     ...officer,
                        //     title: officer.title.name,
                        //     name: { th: officer.nameTH, en: officer.nameEN },
                        //     academicPosition: { th: officer.position.name.th, en: officer.position.name.en },
                        //     titleID: officer.title.id,
                        // }

                        return (
                            <Item
                                key={officer.userID}
                                id={officer.userID}
                                // fullName={setPrefixName(newData)[lang]}
                                fullName={getFullName(officer)}
                                username={officer.username}
                                group={`${translate.get('UM.USERGROUP.GROUP')} ${officer.irb}`}
                                usergroup={officer.usergroup.name[lang]}
                                statusID={officer.status.id}
                                irb={officer.irb}
                                updateDate={officer.updatedDate || officer.createdDate}
                                onDelete={onDelete}
                            />
                        )
                    })}
                </Grid>
            </EmptyData>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    container: {
        margin: theme.spacing(2, 0),
    },
    typo: {
        fontWeight: 'bold',
    },
    sorting: {
        margin: theme.spacing(2, 0),
    },
    select: {
        height: 40,
    },
}))

export default Result
